import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({

  colors: {
    orange: "#FF5805",
    blue: "#15244D",
    lightBlue: "#2E7EA3",
    darkGray: "#737C94",
    white: "#FFFFFF"
  },
  font: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  typography: {
    fontFamily: "Arial, Helvetica, sans-serif",
  },
  palette: {
    primary: {
      main: "#025ba2",
    },
    secondary: {
      main: "#FF5805",
    },
  },

  lightGray: "#555555",
  whiteColor: "#ffffff",
  SectionColor: "#F6F6F6",
  lightBlue: "#6790FC",
  blueColor: "#001B47",
  boldFontWeight: 600,
  dashboardRoutesColor: "#495569",
  sideBarColor: "#001331",
  lihgtestGray: "#C4C4C4",
  navyBlueColor: "#005BA2",
  navyLight: "#30A3F4",
});
export default theme;
